/* jshint browserify: true */
'use strict';

module.exports = {
    throwException: function (message) {
        throw new Error(message);
    },
};
